import { render, staticRenderFns } from "./DownloadPdfSingleReport.vue?vue&type=template&id=53321964&"
import script from "./DownloadPdfSingleReport.vue?vue&type=script&lang=js&"
export * from "./DownloadPdfSingleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports